import classNames from 'classnames';
import React from 'react';

import { Link, LinkType } from '@eika/link';

import { Content } from '../../components/shared/Content';
import { useConfig } from '../../defaultConfig';
import { useAdvisor, useAdvisorImage } from '../../fetchHooks/useAdvisor';
import useTranslation from '../../hooks/useTranslation';

import './AdvisorCard.scss';

const AdvisorCard: React.FC = () => {
    const translated = useTranslation();
    const {
        featureToggles: { useMobileForAdvisor },
    } = useConfig();

    const { data, error, isLoading } = useAdvisor();
    const { data: image } = useAdvisorImage(data?.email);

    if (isLoading || error || !data?.firstName) {
        return <></>;
    }

    const phoneNumber = useMobileForAdvisor ? data.mobilePhone || data.phone : data.phone || data.mobilePhone;

    return (
        <Content>
            <div className={classNames('advisor-card', { 'no-image': !image })}>
                {image && <img className="advisor-card__image" src={image} alt="" />}
                <div className="advisor-card__content">
                    <div>
                        <h2 className="advisor-card__name">
                            {data.firstName} {data.lastName}
                        </h2>
                        <div className="advisor-card__role">{data.title || translated.advisor.title}</div>
                        {phoneNumber && (
                            <div>
                                <span>{translated.advisor.tlf}</span>
                                <span className="advisor-card__field">{phoneNumber}</span>
                            </div>
                        )}
                        {data.email && (
                            <div>
                                <span className="advisor-card__email">{translated.advisor.mail}</span>
                                <span className="advisor-card__field">{data.email}</span>
                            </div>
                        )}
                        <div className="advisor-card__buttons">
                            <div className="advisor-card__buttons--mobile">
                                {data.email && (
                                    <Link href={`mailto:${data.email}`} className="advisor-card__buttons--mail">
                                        {translated.advisor.sendEmail}
                                    </Link>
                                )}
                                {phoneNumber && (
                                    <Link
                                        linkType={LinkType.BUTTON_STANDARD_POSITIVE}
                                        href={`tel:${phoneNumber?.replace(/\s+/g, '')}`}
                                    >
                                        {translated.advisor.call}
                                    </Link>
                                )}
                            </div>
                            <div className="advisor-card__buttons--desktop">
                                {data.email && (
                                    <Link linkType={LinkType.BUTTON_STANDARD_POSITIVE} href={`mailto:${data.email}`}>
                                        {translated.advisor.sendEmail}
                                    </Link>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Content>
    );
};

export default AdvisorCard;
